<template>
    <div class="comment__like" :class="[isMobile ? 'comment__like--show-on-mobile' : 'comment__like--not-for-mobile']" :id="comment.id">
        <div class="comment__like-counter">
            {{likesCount}}
        </div>
        <div class="comment__like-btn"
             :class="likeBtnClass" @click="like">
        </div>
    </div>
</template>

<script>
    import {LIKE_COMMENT_ACTION} from "VueApps/comments/actions/actions";
    import {isCommentShowing} from "VueApps/comments/services/commentStatusResolver";

    const LIKE_STATUS = 'like';
    const UNLIKE_STATUS = 'not_like';

    export default {
        name: "LikeBtn",
        props: {
            comment: {
                required: true,
                type: Object,
            },
            isMobile: {
                type: Boolean,
                required: true
            }
        },
        computed: {
            likeBtnClass: function () {
                return {
                    'comment__like-btn--liked': this.comment.likes.likedByUser
                }
            },
            newStatusAfterClick: function () {
                return this.comment.likes.likedByUser ?
                    UNLIKE_STATUS :
                    LIKE_STATUS;
            },
            likesCount: function () {
                return this.comment.likes.count > 0 ?
                    this.comment.likes.count :
                    null;
            },
            isCommentShowing: function () {
                return isCommentShowing(this.comment);
            },
        },
        methods: {
            like: function () {
                if (this.isCommentShowing) {
                    this.$store.dispatch(LIKE_COMMENT_ACTION, {
                        commentId: this.comment.id,
                        status: this.newStatusAfterClick
                    });
                }
            }
        }
    }
</script>

<style scoped>

</style>
